import {
    showPublicity,
    hidePublicity
} from "./action";

const showPublicityAction = () => showPublicity();
const hidePublicityAction = () => hidePublicity();

export default {
    showPublicityAction: showPublicityAction, hidePublicityAction: hidePublicityAction
}
